import { TEDCustomNumberParser } from './TEDCustomNumberParser';
import { TEDParseNumberMode } from '../FormatterTypes';

export class TEDParseFloat extends TEDCustomNumberParser {
  public static getInstance(): TEDParseFloat {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDParseFloat;

  mode(): TEDParseNumberMode {
    return TEDParseNumberMode.pnmFloat;
  }
}
